import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Grid, Chip } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import EuroIcon from '@mui/icons-material/Euro';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import NearMeIcon from '@mui/icons-material/NearMe';
import { useLanguage } from '../../contexts/LanguageContext';
import { getPrices } from '../../services/storage';

const MotionBox = motion(Box);

export interface PriceItem {
  labelKey: string;
  price: string;
  noteKey: string | null;
  highlight?: boolean;
}

export interface PriceSection {
  id: string;
  number: string;
  titleKey: string;
  subtitleKey: string | null;
  items: PriceItem[];
}

export const PRICE_DATA: PriceSection[] = [
  {
    id: 'einrichtung',
    number: '1',
    titleKey: 'preise.lohn_s1_title',
    subtitleKey: null,
    items: [
      { labelKey: 'preise.lohn_s1_i1', price: '79,90 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s1_i2', price: '239,00 €', noteKey: 'preise.lohn_note_net' },
    ],
  },
  {
    id: 'abrechnung',
    number: '2',
    titleKey: 'preise.lohn_s2_title',
    subtitleKey: 'preise.lohn_s2_sub',
    items: [
      { labelKey: 'preise.lohn_s2_i1', price: '20,00 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s2_i2', price: '19,00 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s2_i3', price: '17,00 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s2_i4', price: '27,00 €', noteKey: 'preise.lohn_note_net', highlight: true },
      { labelKey: 'preise.lohn_s2_i5', price: '25,00 €', noteKey: 'preise.lohn_note_net', highlight: true },
      { labelKey: 'preise.lohn_s2_i6', price: '23,00 €', noteKey: 'preise.lohn_note_net', highlight: true },
      { labelKey: 'preise.lohn_s2_i7', price: '20,00 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s2_i8', price: '12,90 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s2_i9', price: '19,90 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s2_i10', price: '5,00 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s2_i11', price: '15,00 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s2_i12', price: '40,00 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s2_i13', price: '9,50 €', noteKey: 'preise.lohn_note_net' },
    ],
  },
  {
    id: 'bescheinigungen',
    number: '3',
    titleKey: 'preise.lohn_s3_title',
    subtitleKey: null,
    items: [
      { labelKey: 'preise.lohn_s3_i1', price: '32,00 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s3_i2', price: '32,00 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s3_i3', price: '9,90 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s3_i4', price: '49,90 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s3_i5', price: '49,90 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s3_i6', price: '65,00 €', noteKey: 'preise.lohn_note_net' },
    ],
  },
  {
    id: 'antraege',
    number: '4',
    titleKey: 'preise.lohn_s4_title',
    subtitleKey: null,
    items: [
      { labelKey: 'preise.lohn_s4_i1', price: '16,50 €', noteKey: null },
      { labelKey: 'preise.lohn_s4_i2', price: '118,00 €', noteKey: 'preise.lohn_s4_i2_note' },
    ],
  },
  {
    id: 'nebenleistungen',
    number: '5',
    titleKey: 'preise.lohn_s5_title',
    subtitleKey: null,
    items: [
      { labelKey: 'preise.lohn_s5_i1', price: '74,90 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s5_i2', price: '74,90 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s5_i3', price: '60,00 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s5_i4', price: '9,90 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s5_i5', price: '19,90 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s5_i6', price: '39,90 €', noteKey: 'preise.lohn_note_net' },
    ],
  },
  {
    id: 'beratungen',
    number: '6',
    titleKey: 'preise.lohn_s6_title',
    subtitleKey: null,
    items: [
      { labelKey: 'preise.lohn_s6_i1', price: '110,00 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s6_i2', price: '110,00 €', noteKey: 'preise.lohn_note_net' },
      { labelKey: 'preise.lohn_s6_i3', price: '60,00 €', noteKey: 'preise.lohn_note_net' },
    ],
  },
];

export const SECTION_IMAGES: Record<string, string> = {
  einrichtung:     'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80', // Analytics/Dashboard setup
  abrechnung:      'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80', // Accounting desk/calculator
  bescheinigungen: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=800&q=80', // Professional/formal documents
  antraege:        'https://images.unsplash.com/photo-1590650153855-d9e808231d41?w=800&q=80', // Digital/online forms
  nebenleistungen: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80', // Financial charts/overview
  beratungen:      'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80', // Team meeting/consultation
};

const PreisePage: React.FC = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [pricesMap, setPricesMap] = useState<Record<string, string>>({});

  useEffect(() => {
    getPrices().then(setPricesMap).catch(() => {});
  }, []);

  const mergedData = PRICE_DATA.map((section) => ({
    ...section,
    items: section.items.map((item) => ({
      ...item,
      price: pricesMap[item.labelKey] ?? item.price,
    })),
  }));

  return (
    <Box>
      {/* ── Header ── */}
      <Box sx={{ bgcolor: '#f8f8f8', borderBottom: '1px solid #e8e8e8' }}>
        <Container maxWidth="lg" sx={{ py: 10 }}>
          <Chip
            icon={<EuroIcon sx={{ fontSize: '14px !important' }} />}
            label={t('preise.lohn_chip')}
            sx={{ bgcolor: '#eef0fd', color: '#3b52d4', fontWeight: 700, fontSize: '0.72rem', letterSpacing: '0.1em', mb: 3, border: '1px solid #d0d5f8' }}
          />
          <Typography variant="overline" sx={{ color: 'text.secondary', letterSpacing: '3px', mb: 2, display: 'block' }}>
            {t('nav.preise')}
          </Typography>
          <Typography variant="h1" sx={{ mb: 3, fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
            {t('preise.lohn_title')}
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 560, fontSize: '1.1rem', lineHeight: 1.75 }}>
            {t('preise.lohn_subtitle')}
          </Typography>
        </Container>
      </Box>

      {/* ── Cards Grid ── */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={3}>
          {mergedData.map((section, index) => {
            const imgSrc = SECTION_IMAGES[section.id];
            const fromPrice = section.items.reduce((min, item) => {
              const val = parseFloat(item.price.replace(',', '.'));
              return val < min ? val : min;
            }, Infinity);
            const fromPriceStr = fromPrice.toLocaleString('de-DE', { minimumFractionDigits: 2 }) + ' €';

            return (
              <Grid item xs={12} sm={6} key={section.id}>
                <MotionBox
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.08 }}
                  viewport={{ once: true }}
                  onClick={() => navigate(`/preise/${section.id}`, { state: { section } })}
                  sx={{
                    height: 520,
                    borderRadius: 2,
                    overflow: 'hidden',
                    position: 'relative',
                    cursor: 'pointer',
                    backgroundImage: `url(${imgSrc})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.02)',
                      '& .card-blur-overlay': { opacity: 1 },
                      '& .card-hover-info': { opacity: 1, transform: 'translateY(0)' },
                      '& .card-default-content': { opacity: 0 },
                    },
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      inset: 0,
                      background: 'linear-gradient(160deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.72) 100%)',
                      zIndex: 1,
                    },
                  }}
                >
                  {/* Default content */}
                  <Box className="card-default-content" sx={{ transition: 'opacity 0.3s ease', zIndex: 2, position: 'absolute', inset: 0 }}>
                    <Typography
                      variant="overline"
                      sx={{ position: 'absolute', top: 16, left: 16, color: 'white', letterSpacing: '2px', fontSize: '0.65rem', fontWeight: 600 }}
                    >
                      {t('preise.lohn_chip')}
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ position: 'absolute', bottom: 52, left: 16, right: 16, color: 'white', fontWeight: 700, fontSize: '1.5rem', lineHeight: 1.25 }}
                    >
                      {t(section.titleKey)}
                    </Typography>
                    <Box sx={{ position: 'absolute', bottom: 18, left: 16, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.75rem' }}>
                        Details ansehen
                      </Typography>
                      <NearMeIcon sx={{ fontSize: 13, color: 'rgba(255,255,255,0.7)' }} />
                    </Box>
                  </Box>

                  {/* Blur overlay */}
                  <Box
                    className="card-blur-overlay"
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      backdropFilter: 'blur(8px)',
                      bgcolor: 'rgba(0,0,0,0.55)',
                      zIndex: 3,
                      opacity: 0,
                      transition: 'opacity 0.35s ease',
                    }}
                  />

                  {/* Hover info */}
                  <Box
                    className="card-hover-info"
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      zIndex: 4,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'flex-start',
                      px: 3,
                      py: 4,
                      opacity: 0,
                      transform: 'translateY(12px)',
                      transition: 'opacity 0.35s ease, transform 0.35s ease',
                    }}
                  >
                    <Typography
                      variant="overline"
                      sx={{ color: 'rgba(255,255,255,0.6)', letterSpacing: '2px', fontSize: '0.65rem', mb: 1.5 }}
                    >
                      {t('preise.lohn_chip')}
                    </Typography>
                    <Typography variant="h4" sx={{ color: 'white', fontWeight: 700, mb: 2, lineHeight: 1.3 }}>
                      {t(section.titleKey)}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: 'rgba(255,255,255,0.75)', lineHeight: 1.7, mb: 1, fontSize: '0.9rem' }}
                    >
                      {section.items.length} Leistungen
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, mb: 3, fontSize: '0.85rem' }}
                    >
                      ab {fromPriceStr} zzgl. MwSt.
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: 'white' }}>
                      <Typography variant="caption" sx={{ fontSize: '0.8rem', letterSpacing: '1px', textTransform: 'uppercase' }}>
                        Preisliste ansehen
                      </Typography>
                      <ArrowForwardIcon sx={{ fontSize: 14 }} />
                    </Box>
                  </Box>
                </MotionBox>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default PreisePage;
